import { useCallback, useMemo } from "react";
import { useApiService } from "./index";
import {
  TenantSettings,
  UpdateTenantSettingsRequest,
} from "../types/tenantSettings";

export const useTenantSettingsService = () => {
  const { get, put } = useApiService();

  const getTenantSettings = useCallback(async () => {
    const response = await get<TenantSettings>("/api/tenant-settings");
    return response.data;
  }, [get]);

  const updateTenantSettings = useCallback(
    async (payload: UpdateTenantSettingsRequest) => {
      const response = await put<TenantSettings>("/api/tenant-settings", payload);
      return response.data;
    },
    [put]
  );

  return useMemo(
    () => ({
      getTenantSettings,
      updateTenantSettings,
    }),
    [getTenantSettings, updateTenantSettings]
  );
};
